const oecmOverlap = [
  { value: 1, label: '0% - no overlap' },
  { value: 2, label: '1-10%' },
  { value: 3, label: '11-20%' },
  { value: 4, label: '21-30%' },
  { value: 5, label: '31-40%' },
  { value: 6, label: '41-50%' },
  { value: 7, label: '51-60%' },
  { value: 8, label: '61-70%' },
  { value: 9, label: '71-80%' },
  { value: 10, label: '81-90%' },
  { value: 11, label: '91-99%' },
  { value: 12, label: '100% - completely covered' }
]

export default oecmOverlap
